import { MarkdownBody } from "./MarkdownBody";
import { cleanChatMarkdown } from "@/lib/cleanText";

interface StreamingMessageProps {
  content: string;
}

export function StreamingMessage({ content }: StreamingMessageProps) {
  if (!content) {
    return (
      <div className="flex justify-start mb-3">
        <div className="frost-card rounded-2xl rounded-bl-md px-4 py-2.5">
          <div className="flex gap-1">
            <span className="w-2 h-2 bg-ink-light/70 rounded-full animate-pulse" />
            <span className="w-2 h-2 bg-ink-light/70 rounded-full animate-pulse [animation-delay:150ms]" />
            <span className="w-2 h-2 bg-ink-light/70 rounded-full animate-pulse [animation-delay:300ms]" />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex justify-start mb-3 min-w-0">
      <div className="max-w-[85%] frost-card rounded-2xl rounded-bl-md px-4 py-2.5 text-ink">
        <MarkdownBody content={cleanChatMarkdown(content)} />
        <span className="inline-block w-1.5 h-4 bg-accent/70 ml-0.5 animate-pulse align-middle" />
      </div>
    </div>
  );
}
